if (!customElements.get('countdown-timer')) {
  class CountdownTimer extends HTMLElement {
    connectedCallback() {
      this.daysWrap = this.querySelector('[data-unit-wrap="days"]');
      this.daysEl = this.querySelector('[data-unit="days"]');
      this.hoursEl = this.querySelector('[data-unit="hours"]');
      this.minutesEl = this.querySelector('[data-unit="minutes"]');
      this.secondsEl = this.querySelector('[data-unit="seconds"]');

      this.isDailyReset = this.hasAttribute('data-daily-madrid-reset');

      if (this.isDailyReset) {
        this.tick();
        this.interval = setInterval(() => this.tick(), 1000);
        return;
      }

      const endTime = Date.parse(this.dataset.endTime);
      if (isNaN(endTime)) {
        this.hidden = true;
        return;
      }
      this.update(endTime);
      this.interval = setInterval(() => this.update(endTime), 1000);
    }

    disconnectedCallback() {
      if (this.interval) clearInterval(this.interval);
    }

    // Calcula la medianoche de HOY en hora de España (Europe/Madrid),
    // ajustando automáticamente el horario de verano/invierno.
    getMadridEndOfTodayTimestamp() {
      const now = new Date();
      const parts = Object.fromEntries(
        new Intl.DateTimeFormat('en-US', {
          timeZone: 'Europe/Madrid',
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hour12: false,
        })
          .formatToParts(now)
          .map((p) => [p.type, p.value])
      );
      const offsetMinutes =
        (Date.UTC(parts.year, parts.month - 1, parts.day, parts.hour, parts.minute, parts.second) -
          now.getTime()) /
        60000;
      return Date.UTC(parts.year, parts.month - 1, parts.day, 23, 59, 59) - offsetMinutes * 60000;
    }

    tick() {
      const endTime = this.getMadridEndOfTodayTimestamp();
      this.update(endTime);
    }

    update(endTime) {
      const remaining = endTime - Date.now();

      if (remaining <= 0) {
        if (this.isDailyReset) return; // el próximo tick calcula el nuevo "hoy" automáticamente
        clearInterval(this.interval);
        this.hidden = true;
        return;
      }

      const totalSeconds = Math.floor(remaining / 1000);
      const days = Math.floor(totalSeconds / 86400);
      const hours = Math.floor((totalSeconds % 86400) / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      if (this.daysEl) this.daysEl.textContent = String(days).padStart(2, '0');
      if (this.daysWrap) this.daysWrap.hidden = days === 0;
      this.hoursEl.textContent = String(hours).padStart(2, '0');
      this.minutesEl.textContent = String(minutes).padStart(2, '0');
      this.secondsEl.textContent = String(seconds).padStart(2, '0');

      this.classList.toggle('is-urgent', remaining <= 10 * 60 * 1000);
      this.classList.toggle('is-critical', remaining <= 2 * 60 * 1000);
    }
  }

  customElements.define('countdown-timer', CountdownTimer);
}
